import { render } from "./TicketView.vue?vue&type=template&id=336f3890"
import script from "./js/ticketView.js?vue&type=script&lang=js&external"
export * from "./js/ticketView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__